<template>
  <div class="zAfifx">
    <div>
      <Tooltip placement="left" theme="light" max-width="150">
        <div class="middle" >
          <i class="iconfont icon-zixu"></i>
          <p>在线客服</p>
        </div>
        <div class="contact-list" slot="content">
          <div class="contact-item">
            <div class="iconfont icon-telephone"></div>
            <div class="content">
              <p>咨询电话</p>
              <p>400-998-0137</p>
            </div>
          </div>
          <div class="contact-item cursor" id="zaixiankefu">
            <div class="iconfont icon-kefu1"></div>
            <div class="content">在线客服</div>
          </div>
        </div>
      </Tooltip>
    </div>
    

    <div>
      <Tooltip placement="left" theme="light" max-width="120">
        <Routing :url="nuxtUrl" href="/download" bl>
          <div class="top">
            <i class="iconfont icon-shouji"></i>
            <p>下载APP</p>
          </div>
        </Routing>

        <div slot="content">
          <img
            src="https://oss.zhulogic.com/inspirationImage/lgy/tRZMxbrShjNMejiwDsM3TJsmcPbKPKfwnH.png"
            alt
          />
          <p>住逻辑APP下载</p>
          <p class="txt">让好设计完美落地</p>
        </div>
      </Tooltip>
    </div>

    <BackTop style="z-index:9500" :height="500" :right="0" :bottom="25">
      <div class="con">
        <div class="back-top">
          <i class="iconfont icon-dingbu"></i>
          <p>返回顶部</p>
        </div>
      </div>
    </BackTop>

    <div class="couponButton" v-if="newpeople">
      <i class="iconfont icon-xinrenli-"></i>
      <p>新人礼</p>
    </div>
    <user-upload
      :ossKey="ossType"
      :ossUrl="ossUrl"
      ref="UserUpload"
      @uploadHanldeEmit="uploadHanldeEmit"
    ></user-upload>
  </div>
</template>

<script>
import UserUpload from '../user-upload/user-upload.vue'
import Routing from '../nav/routing.vue'

export default {
  name: 'ZAfifx',
  data() {
    return {
      fullPath: null,
      baseUrl: null,
    }
  },
  props: {
    newpeople: {
      type: Boolean,
      default: false,
    },
    ossType: {
      type: Object,
      default: function() {
        return {}
      },
    },
    ossUrl: {
      type: String,
      default: '',
    },
    nuxtUrl: {
      type: String,
      default: '',
    },
    nextUrl: {
      type: String,
      default: '',
    },
  },
  components: { UserUpload, Routing },
  methods: {
    udeskHandle(product = null) {
      this.$nextTick(() => {
        ;(function(a, h, c, b, f, g) {
          a['UdeskApiObject'] = f
          a[f] =
            a[f] ||
            function() {
              ;(a[f].d = a[f].d || []).push(arguments)
            }
          g = h.createElement(c)
          g.async = 1
          g.charset = 'utf-8'
          g.src = b
          c = h.getElementsByTagName(c)[0]
          c.parentNode.insertBefore(g, c)
        })(
          window,
          document,
          'script',
          'https://assets-cli.udesk.cn/im_client/js/udeskApi.js',
          'ud'
        )
        ud({
          code: '260bd3ji',
          link: 'https://zhulogic.udesk.cn/im_client/?web_plugin_id=42958',
          mode: 'inner',
          color: '#308697',
          targetSelector: '#zaixiankefu',
          selector:
            '.afterSales,#udeskIdContart,#aftersale_content,#shaleContent',
          noBubble: false,
        })

        if (product) {
          ud('showPanel')
        }
      })
    },
    /* 上传灵感源 */
    openInspiration() {
      this.$emit('getOssType')
      this.$refs.UserUpload.open(1, '', '')
    },
    /* 上传产品 */
    openProducts() {
      this.$emit('getOssType')
      this.$refs.UserUpload.open(2, '', '')
    },
    uploadHanldeEmit(data, type) {
      this.$emit('uploadHanlde', data, type)
    },
  },
  created() {
    this.$on('global:sendUdesk', () => {
      this.udeskHandle('product')
    })
  },
  mounted() {
    this.udeskHandle()
  },
  watch: {
    $route: function() {
      this.fullPath = this.$router.currentRoute.fullPath
      this.baseUrl = this.$router.options.base
    },
  },
}
</script>
